import { createSlice, PayloadAction } from '@reduxjs/toolkit'

//The initial state is taken from localstorage, if there is none - null

const initialState: any = {
    charts: localStorage.getItem('charts') ? JSON.parse(localStorage.getItem('charts') || '[]') : []
}

//Creating a slice with state interaction functions

export const dashboardReducer = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        addChart: (state, action: PayloadAction<object>): any => ({
            ...state,
            charts: [
                ...state.charts,
                action.payload
            ]
        }),
        deleteChart: (state, action: PayloadAction<any>): any => ({
            ...state,
            charts: state.charts.filter((el: any) => el.name !== action.payload),

        }),
        editChart: (state, action: PayloadAction<any>): any => ({
            ...state,
            charts: action.payload,

        }),

    },
})


export const { addChart, deleteChart, editChart} = dashboardReducer.actions

export default dashboardReducer.reducer